import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import Button, { ButtonVariant } from "components/base/Button";
import ModalSacar from "./ModalSacar";
import { ContaType } from "services/contaService";

interface BotaoSacarProps {
    conta: ContaType;
    size?: "sm" | "lg";
    variant?: ButtonVariant;
    title?: string;
    showText?: boolean;
}

const BotaoSacar: React.FC<BotaoSacarProps> = ({
    conta,
    size = "sm",
    variant = "outline-warning",
    title = "Sacar",
    showText = false
}) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    return (
        <>
            <Button
                variant={variant}
                size={size}
                onClick={handleClick}
                title={title}
            >
                <FontAwesomeIcon icon={faArrowUp} className={showText ? "me-2" : ""} />
                {showText && "Sacar"}
            </Button>

            <ModalSacar
                show={showModal}
                onHide={handleClose}
                conta={conta}
            />
        </>
    );
};

export default BotaoSacar; 